module.exports = __webpack_public_path__ + "static/media/plp3.756978c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/PLP/plp3.png
// module id = 1255
// module chunks = 0